import { Menu, X } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { useHeaderNavigation } from '../hooks/useHeaderNavigation';
import { DesktopNavigation, MobileNavigation, QuoteButton } from './navigation/HeaderNavigation';

const Header = () => {
  const { solid, mobileOpen, toggleMenu, requestQuote } = useHeaderNavigation();
  return (
    <header data-testid="site-header" className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${solid ? 'bg-background/90 backdrop-blur-xl border-b border-border' : 'bg-transparent'}`}>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <NavLink data-testid="header-home-link" to="/" className="flex items-center group">
          <img src="https://customer-assets.emergentagent.com/job_documentation-76/artifacts/iyu3j9j9_Asset%205.png" alt="Membratek Membran Yapilar" className="h-8 sm:h-9 w-auto object-contain" draggable="false" />
        </NavLink>
        <DesktopNavigation />
        <div className="flex items-center gap-3">
          <QuoteButton onClick={requestQuote} />
          <button data-testid="header-menu-toggle" type="button" aria-expanded={mobileOpen} aria-controls="mobile-navigation" onClick={toggleMenu} className="md:hidden p-2 text-white" aria-label="Menu">
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {mobileOpen && <MobileNavigation requestQuote={requestQuote} />}
    </header>
  );
};

export default Header;